const PriceFloat = value => Number.parseFloat(value).toFixed(2);
const PriceString = value => '$ ' + PriceFloat(value);
const Percent = value => Number.parseFloat(Number.parseFloat(value) * 100).toFixed(2);


export {PriceFloat, PriceString, Percent};
